export default __webpack_public_path__ + "static/media/hidraulic23.0e302183.jpeg";